import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import PageHeaderSetting from '../shared/pageHeader/PageHeaderSetting';
import PerfectScrollbar from "react-perfect-scrollbar";
import Footer from "../shared/Footer";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const MASK_VALUE = "******"; // 🔐 Mask gösterimi

const SettingsRecaptchaForm = () => {
  const [apiSettings, setApiSettings] = useState({
    recaptcha_site_key: "",
    recaptcha_secret_key: "",
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  useEffect(() => {
    fetchApiData();
  }, []);

  const fetchApiData = async () => {
    try {
      const resp = await axios.get(`${BASE_URL}/api/settings/1`);
      const data = resp.data || {};
      // 🔐 Eğer secret doluysa maskeli göster
      if (data.recaptcha_secret_key) data.recaptcha_secret_key = MASK_VALUE;
      setApiSettings((prevState) => ({
        ...prevState,
        ...data,
      }));
    } catch (err) {
      console.error("API verisi çekme hatası:", err);
      toast.error("API ayarları alınamadı!");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setApiSettings((prev) => ({
      ...prev,
      [name]: value === MASK_VALUE ? prev[name] : value,
    }));
  };

  const handleSecretFocus = (e) => {
    if (e.target.value === MASK_VALUE) {
      e.target.value = "";
      setApiSettings((prev) => ({
        ...prev,
        [e.target.name]: "",
      }));
    }
  };

  const handleSave = async () => {
    try {
      const dataToSend = { ...apiSettings };
      if (dataToSend.recaptcha_secret_key === MASK_VALUE) {
        delete dataToSend.recaptcha_secret_key; // 🔐 Değişmediyse gönderme
      }
      await axios.put(`${BASE_URL}/api/settings/1`, dataToSend);
      toast.success(getText("SUCCESS_API_UPDATED"));
      fetchApiData();
    } catch (error) {
      console.error("API Bilgileri kaydedilemedi:", error);
      toast.error("Kayıt hatası oluştu!");
    }
  };

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card mb-0">
            <div className="card-body">

              {/*  Google reCAPTCHA Alanları */}
              <div className="mb-3">
                <label className="form-label fw-bold">{getText("LABEL_RECAPTCHA_SITE_KEY")}</label>
                <input
                  type="text"
                  className="form-control"
                  name="recaptcha_site_key"
                  placeholder={getText("PLACEHOLDER_RECAPTCHA_SITE_KEY")}
                  value={apiSettings.recaptcha_site_key || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">{getText("LABEL_RECAPTCHA_SECRET_KEY")}</label>
                <input
                  type="password"
                  className="form-control"
                  name="recaptcha_secret_key"
                  placeholder={getText("PLACEHOLDER_RECAPTCHA_SECRET_KEY")}
                  value={apiSettings.recaptcha_secret_key || ""}
                  onChange={handleChange}
                  onFocus={handleSecretFocus}
                  autoComplete="off"
                />
              </div>

              {/* KAYDET BUTONU */}
              <div className="d-flex justify-content-center">
                <button className="btn btn-primary" onClick={handleSave}>
                  <FiSave className="me-2" /> {getText("SAVE_BTN")}
                </button>
              </div>

            </div>
          </div>
        </div>
        
      </PerfectScrollbar>
    </div>
  );
};

export default SettingsRecaptchaForm;
